export default {
  type: 'institutions',
  name: 'Institution',
  permissions: {
    view: { app: 'people', role: 'people' },
    insert: { app: 'people', role: 'people' },
    update: { app: 'people', role: 'people' },
    delete: { app: 'people', role: 'people' }
  },
  search: {
    search: 'allInstitutions',
    orderBy: {
      type: 'InstitutionsOrderBy',
      default: 'INST_NAME_ASC'
    },
    fields: [
      {
        name: 'tsvSearch',
        label: 'Search',
        filterType: 'matches',
        searchOnly: true
      },
      {
        name: 'instName',
        label: 'Institution Name',
        searchable: false,
        order: 'INST_NAME'
      },
      {
        name: 'fullAddress',
        label: 'Address',
        searchable: false,
        export: false,
        order: 'FULL_ADDRESS'
      },
      {
        name: 'address1',
        showResults: false,
        searchable: false
      },
      {
        name: 'address2',
        showResults: false,
        searchable: false
      },
      {
        name: 'city',
        showResults: false,
        searchable: false
      },
      {
        name: 'state',
        showResults: false,
        searchable: false
      },
      {
        name: 'zipCode',
        showResults: false,
        searchable: false
      },
      {
        name: 'countryCode',
        showResults: false,
        searchable: false
      },
      {
        name: 'instType',
        label: 'Type',
        searchable: false,
        order: 'INST_TYPE'
      },
      {
        name: 'smallBusiness',
        searchable: false,
        type: 'Boolean',
        order: 'SMALL_BUSINESS'
      }
    ]
  },
  save: {
    fields: [
      {
        field: 'instName',
        required: true
      },
      'address1',
      'address2',
      'city',
      'state',
      'countryCode',
      'zipCode',
      {
        field: 'smallBusiness',
        type: 'Boolean',
        required: true,
        default: false
      },
      'instType'
    ],
    key: ['instName'],
    input: 'institution',
    create: 'createInstitution',
    delete: 'deleteInstitution',
    update: 'updateInstitution'
  },
  load: {
    nodeId: 'institution',
    key: 'institutionByInstName'
  },
  form: {
    createHeader: 'Create Institution',
    editHeader: 'Edit Institution - ${instName}',
    printHeader: 'Institution - ${instName}',
    schema: [
      {
        name: 'instName',
        label: 'Institution Name',
        labelWidth: 2,
        required: true
      },
      [
        {
          name: 'address1',
          label: 'Address 1',
          labelWidth: 4,
          width: 6
        },
        {
          name: 'address2',
          label: 'Address 2',
          labelWidth: 4,
          width: 6
        }
      ],
      [
        {
          name: 'city',
          labelWidth: 2,
          width: 6
        },
        {
          name: 'state',
          labelWidth: 6,
          width: 2
        },
        {
          name: 'zipCode',
          label: 'Zip',
          labelWidth: 2,
          width: 4
        }
      ],
      [
        {
          name: 'countryCode',
          label: 'Country',
          labelWidth: 2,
          width: 6,
          type: 'select',
          options: {
            allowNull: true,
            lookup: 'allCountries',
            value: 'countryCode',
            text: 'countryName',
            params: [
              {
                field: 'orderBy',
                passArray: true,
                type: 'CountriesOrderBy',
                default: 'COUNTRY_NAME_ASC'
              }
            ]
          }
        },
        {
          name: 'smallBusiness',
          labelWidth: 4,
          width: 6,
          type: 'checkbox'
        }
      ],
      {
        name: 'instType',
        label: 'Type',
        labelWidth: 1
      }
    ]
  }
}
